import styled from "@emotion/styled";
import Skeleton from "@mui/material/Skeleton";

const Question = styled((props) => {
	return (
		<div className={props.className}>
			<Skeleton variant="rounded" height={230} />
		</div>
	);
})`
  margin-top: 16px;
`;

export const SingleQuestion = styled((props) => {
	return (
		<div className={props.className}>
			<Skeleton variant="rounded" height={50} />
			<Question />
		</div>
	);
})`
  ${Question} {
    margin: 0 0 16px;
  }
`;

export const Questions = styled((props) => {
	return (
		<div className={props.className}>
			<Skeleton variant="rounded" height={50} sx={{ mb: "16px" }} />
			<Question />
			<Question />
			<Question />
			<Question />
			<Question />
		</div>
	);
})`
  ${Question} {
    margin: 0 0 16px;
  }
`;

export default Question;
